const adjectives = [
  'funny', 'silent', 'brave', 'happy', 'angry', 'lazy', 'wild', 'noisy',
  'smart', 'shy', 'quick', 'sleepy', 'cool', 'sneaky', 'grumpy', 'fuzzy',
  'gentle', 'crazy', 'tiny', 'lucky', 'weird', 'silly', 'nervous', 'lonely'
];

const animals = [
  'bear', 'wolf', 'cat', 'dog', 'panda', 'tiger', 'lion', 'fox', 'eagle',
  'otter', 'rabbit', 'monkey', 'zebra', 'sloth', 'bat', 'duck', 'frog',
  'cow', 'goose', 'deer', 'beaver', 'horse', 'chicken', 'leopard', 'mouse'
];

export function generateRandomLocalPart(): string {
  const adjective = adjectives[Math.floor(Math.random() * adjectives.length)];
  const animal = animals[Math.floor(Math.random() * animals.length)];
  const number = Math.floor(1000 + Math.random() * 9000); // 4 цифры

  return `${adjective}${animal}-${number}`;
}
